export const colors = {}